import Box from "@mui/material/Box";

/** A small green dot with a slow ripple: something is running right now. */
export default function LiveDot({ size = 8 }: { size?: number }) {
  return (
    <Box
      component="span"
      aria-hidden
      sx={{
        position: "relative",
        display: "inline-block",
        flexShrink: 0,
        width: size,
        height: size,
        borderRadius: "50%",
        bgcolor: "success.main",
        "@keyframes sxq-live-ripple": {
          "0%": { transform: "scale(1)", opacity: 0.6 },
          "100%": { transform: "scale(2.6)", opacity: 0 },
        },
        "&::after": {
          content: '""',
          position: "absolute",
          inset: 0,
          borderRadius: "50%",
          bgcolor: "success.main",
          animation: "sxq-live-ripple 1.8s ease-out infinite",
        },
        "@media (prefers-reduced-motion: reduce)": { "&::after": { animation: "none" } },
      }}
    />
  );
}

/**
 * The `sx` of the box a lone dot sits in: bigger than the dot, a hover target
 * for its tooltip and room for its ripple when it starts a (wrapped) line.
 */
export const LIVE_DOT_BOX = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 16,
  height: 16,
} as const;
